import ComeOnSettings from '@/modules/integrations/types/comeon/ComeOnSettings'

export default Object.freeze({
  type: 'comeon',
  title: 'Integrations_ComeOn',
  category: 'Integrations_ComeOn_Category',
  description: 'Integrations_ComeOn_Description',
  image: require('@/img/integrations/comeon.svg'),
  defaultParams: {
    url: null,
    port: 443
  },
  requiresAdmin: false,
  components: {
    settings: ComeOnSettings,
    overview: null
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/third-party-integrations'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/comeon/index.js